import React, { FunctionComponent } from "react";
import { Image, ImageField, RichText } from "@sitecore-jss/sitecore-jss-react";
import "./FooterInfo.scss";

interface FooterInfoProps {
  logoImage: ImageField;
  info: { value: string };
}

const FooterInfo: FunctionComponent<FooterInfoProps> = ({
  logoImage,
  info,
}) => {
  return (
    <div className="FooterInfo">
      <div className="FooterInfo__logo">
        <Image field={logoImage} width={140.35} height={40} />
      </div>
      <RichText className="FooterInfo__info" field={info} />
    </div>
  );
};

export default FooterInfo;
